import YouTubeIframeLoader from 'youtube-iframe';
import Vimeo from '@vimeo/player';
import computedStyle from 'computed-style';
import isIEbrowser from '../../../resources/scripts/helpers/is-IE';

class BrixRichText {
  static init(...parameters) {
    return new BrixRichText(...parameters);
  }

  constructor(container) {
    this.container = container;

    if (container) {
      this.toggleReadMore();
      const IE = isIEbrowser();

      this.poster = container.querySelector('.image.-grid');
      this.video = container.querySelector('.video.-grid');
      this.objectFit = container.querySelector('.image.-cover');
      this.paused = true;

      if (this.objectFit && IE) {
        window.objectFitPolyfill(this.objectFit);
      }

      if (this.video && computedStyle(this.video, 'visibility') === 'visible') {
        this.videoType = this.video.dataset.videoType;
        this.videoStart = this.video.dataset.videoStart;

        if (this.videoType === 'youtube') {
          this.initYotube();
        }

        if (this.videoType === 'vimeo') {
          this.initVimeo();
        }
      }
    }
  }

  initYotube() {
    const { video } = this;

    const player = video.querySelector('.player');
    const { videoId } = video.dataset;
    if (player && videoId) {
      YouTubeIframeLoader.load((YT) => {
        this.youtube = new YT.Player(player, {
          height: '100%',
          width: '100%',
          videoId,
          events: {
            onReady: (event) => {
              this.iframe = video.querySelector('iframe');
              event.target.mute();
              event.target.playVideo();
              this.onReady();
            },
            onStateChange: (event) => {
              switch (event.data) {
                case YT.PlayerState.PLAYING:
                  this.paused = false;
                  this.onPlay();
                  break;

                case YT.PlayerState.PAUSED:
                  this.paused = true;
                  this.onPause();
                  break;

                case YT.PlayerState.ENDED:
                  event.target.mute();
                  event.target.playVideo();
                  break;

                default:
              }
            },
          },
          playerVars: {
            start: this.videoStart,
            autoplay: 1, // Auto-play the video on load
            controls: 0, // Show pause/play buttons in player
            showinfo: 0, // Hide the video title
            modestbranding: 1, // Hide the Youtube Logo
            loop: 1, // Run the video in a loop
            fs: 0, // Hide the full screen button
            cc_load_policy: 0, // Hide closed captions
            iv_load_policy: 3, // Hide the Video Annotations
            autohide: 0,
            rel: 0, // Hide video controls when playing
            disablekb: 1, // disable the keyboard controls
          },
        });
      });
    }
  }

  initVimeo() {
    this.iframe = this.video.querySelector('iframe');

    // this.onReady();
    const player = this.video.querySelector('.player');
    if (player) {
      let isReady = false;
      const vimeo = new Vimeo(player);
      vimeo.ready().then(() => {
        vimeo.setCurrentTime(this.videoStart);
      });
      vimeo.on('play', () => {
        if (!isReady) {
          isReady = true;
          this.onReady();
        }
        vimeo.on('timeupdate', (data) => {
          if (data.percent > 0) {
            vimeo.off('timeupdate');
            this.paused = false;
            this.onPlay();
          }
        });
      });
      vimeo.on('pause', () => {
        vimeo.off('timeupdate');
        this.paused = true;
        this.onPause();
      });
      vimeo.setVolume(0);
      vimeo.getPaused().then((paused) => {
        if (!paused) {
          if (!isReady) {
            isReady = true;
            this.onReady();
          }
        } else {
          vimeo.off('timeupdate');
        }
        this.paused = paused;
      });
      this.vimeo = vimeo;
    }
  }

  onReady() {
    this.onResize();
    window.addEventListener('resize', event => this.onResize(event));
  }

  onPlay() {
    this.poster.style.opacity = 0;
  }

  onPause() {
    this.poster.style.opacity = 1;
  }

  onResize() {
    const { container, iframe } = this;
    let width = container.offsetWidth;
    let height = container.offsetHeight;

    if ((width / height) > (16 / 9)) {
      height = Math.ceil((width / 16) * 9) + 2; // Fix rounding error
      width = Math.ceil(width) + 2; // Fix rounding error

      iframe.style.width = `${width}px`;
      iframe.style.height = `${height}px`;
    } else {
      width = Math.ceil((height / 9) * 16) + 2; // Fix rounding error
      height = Math.ceil(height) + 2; // Fix rounding error

      iframe.style.width = `${width}px`;
      iframe.style.height = `${height}px`;
    }
  }

  toggleReadMore() {
    const readMoreButton = this.container.querySelector('.rich-text-read-more');
    const content = this.container.querySelector('.content');

    if (readMoreButton) {
      readMoreButton.addEventListener('click', () => {
        readMoreButton.classList.add('-show-more');
      });

      const readLessButton = document.createElement('button');
      readLessButton.classList.add('rich-text-read-less');
      readLessButton.classList.add('-clean');
      content.appendChild(readLessButton);

      readLessButton.addEventListener('click', () => {
        readMoreButton.classList.remove('-show-more');
      });
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-rich-text', BrixRichText.init);
}
